import { SwitchProps } from "@origin-digital/ods-core";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "src/context/AppContext";

export const usePageTitleSection = () => {
  const {
    context: { user, featureFlags },
  } = useAppContext();
  const isHomeUser = Boolean(user?.role === "USER" && !user.main_company);
  const navigate = useNavigate();

  const groupByProjectsSwitchProps: Partial<SwitchProps> = React.useMemo(() => {
    return {
      onChange: () => navigate("/projects"),
      "data-id": "pageTitleSection.groupByProjectsSwitch",
    };
  }, [navigate]);

  return {
    isHomeUser,
    featureFlags,
    groupByProjectsSwitchProps,
  };
};
